"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";

var NumberControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(NumberControl, _BaseControl);

  function NumberControl() {
    _classCallCheck(this, NumberControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberControl).apply(this, arguments));
  }

  _createClass(NumberControl, [{
    key: "dispose",
    value: function dispose() {
      this.$_element.dxNumberBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.$_element.dxNumberBox('instance');
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxNumberBox(_objectSpread({}, this._buildControlProps()));
    }
  }]);

  return NumberControl;
}(BaseControl);

export { NumberControl as default };